"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SettlementPaymentStatus = void 0;
const legacy_options_1 = require("@daytrip/legacy-options");
Object.defineProperty(exports, "SettlementPaymentStatus", { enumerable: true, get: function () { return legacy_options_1.SettlementPaymentStatus; } });
const type_graphql_1 = require("type-graphql");
// export enum SettlementPaymentStatus {
//     PENDING = "Pending",
//     READY_FOR_PAYMENT = "Ready for Payment",
//     PAID = "Paid",
//     UNPAID = "Unpaid",
// }
(0, type_graphql_1.registerEnumType)(legacy_options_1.SettlementPaymentStatus, {
    name: "SettlementPaymentStatus",
});
//# sourceMappingURL=settlement-payment-status.js.map